/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Types
 */
export type GetTransactionDetailResponseType = typeof GetTransactionDetailResponseType[keyof typeof GetTransactionDetailResponseType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionDetailResponseType = {
  DEPOSIT_DIGITAL: 'DEPOSIT_DIGITAL',
  WITHDRAW_FIAT: 'WITHDRAW_FIAT',
  WITHDRAW_DIGITAL: 'WITHDRAW_DIGITAL',
  DEPOSIT_FIAT: 'DEPOSIT_FIAT',
  COMMODITIES_DEPOSIT: 'COMMODITIES_DEPOSIT',
  COMMODITIES_WITHDRAW: 'COMMODITIES_WITHDRAW',
  EXCHANGE: 'EXCHANGE',
  REPAYMENT_EXCHANGE: 'REPAYMENT_EXCHANGE',
  BILL_PAYMENT: 'BILL_PAYMENT',
  TRANSFER_SELF: 'TRANSFER_SELF',
  TRANSFER_P2P: 'TRANSFER_P2P',
  TRADER_MINT: 'TRADER_MINT',
  TRADER_BURN: 'TRADER_BURN',
  GENERAL_INSTRUCTION: 'GENERAL_INSTRUCTION',
  BORROW: 'BORROW',
  REPAY: 'REPAY',
  INTEREST: 'INTEREST',
  FEE_PAYOUT: 'FEE_PAYOUT',
  FEE: 'FEE',
  EARN_SUBSCRIPTION: 'EARN_SUBSCRIPTION',
  EARN_REDEMPTION: 'EARN_REDEMPTION',
  EARN_REDEMPTION_FEE: 'EARN_REDEMPTION_FEE',
  EARN_REWARD: 'EARN_REWARD',
  CARD_TOPUP: 'CARD_TOPUP',
  CARD_WITHDRAW: 'CARD_WITHDRAW',
  CARD_BORROW: 'CARD_BORROW',
} as const;
